export default __webpack_public_path__ + "static/media/1x_Collage.012edec4.png";